var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgXlsicon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16.67 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#9e9e9e;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Excel_01") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M12.73,11.37l-1.65,2,1.65,2a.84.84,0,0,1-.11,1.18.85.85,0,0,1-1.18-.11L10,14.63,8.56,16.37a.83.83,0,0,1-.64.3.91.91,0,0,1-.54-.19.84.84,0,0,1-.1-1.18l1.64-2-1.64-2A.83.83,0,1,1,8.56,10.3L10,12l1.44-1.73a.84.84,0,1,1,1.29,1.07Zm5.6-2.63v7.09A4.17,4.17,0,0,1,14.17,20H5.83a4.17,4.17,0,0,1-4.16-4.17V4.17A4.17,4.17,0,0,1,5.83,0H9.59a5.81,5.81,0,0,1,4.13,1.71l2.9,2.91a5.79,5.79,0,0,1,1.71,4.12ZM12.54,2.88a4.3,4.3,0,0,0-.87-.67V5.83a.84.84,0,0,0,.83.84h3.62a4.41,4.41,0,0,0-.68-.88Zm4.13,5.85a2.88,2.88,0,0,0,0-.41H12.5A2.51,2.51,0,0,1,10,5.82V1.68H5.83a2.51,2.51,0,0,0-2.5,2.5V15.83a2.51,2.51,0,0,0,2.5,2.5h8.34a2.51,2.51,0,0,0,2.5-2.5V8.74Z",
    transform: "translate(-1.67)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgXlsicon);
export default __webpack_public_path__ + "static/media/xlsicon.5e2105c89d58ce62a01f7baade6e6aeb.svg";
export { ForwardRef as ReactComponent };